import { useState } from 'react';

export interface IUseError {
  error: string;
  onError: (error: any) => void;
  onErrorClose: () => void;
}

export default () => {
  const params = new URLSearchParams(window.location.search);
  const [errorState, setErrorState] = useState(
    params.get('error_description') || params.get('error') || '',
  );

  function handleError(error: any) {
    const nextErrorState = error.message ? error.message : error;
    setErrorState(nextErrorState);
  }

  function resetError() {
    setErrorState(null);
  }

  return {
    error: errorState,
    onError: handleError,
    onErrorClose: resetError,
  } as IUseError;
};
